module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solution-content",
    class: {
      hidden: !_vm.isActive
    }
  }, [_c('div', {
    staticClass: "solution-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.image
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "solution-heading wwf-font"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "solution-text"
  }, [_c('p', [_vm._v(_vm._s(_vm.item.text))]), _vm._v(" "), _c('div', {
    ref: "articles",
    staticClass: "solution-links"
  }, _vm._l((_vm.item.content), function(copy, i) {
    return _c('p', {
      key: 'copy' + i
    }, [_c('span', {
      staticClass: "copy-text",
      domProps: {
        "innerHTML": _vm._s(copy)
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "solution-readmore"
  }, [_c('a', {
    staticClass: "wwf-font",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("Learn more "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54bdb1ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/hub/SolutionsContent.vue
// module id = 688
// module chunks = 0